// 是或否
export const YES_OR_NO_OPTIONS = [
  {
    label: '是',
    value: 1,
  },
  {
    label: '否',
    value: 0,
  },
];


// 时间范围
export const TIME_RANGE = {
  today: 'today',
  yesterday: 'yesterday',
  'this-week': 'this-week',
  'last-week': 'last-week',
  'this-month': 'this-month',
  'last-month': 'last-month',
  'this-quarter': 'this-quarter',
  'last-quarter': 'last-quarter',
  'this-year': 'this-year',
  'last-year': 'last-year',
  'self-time': 'self-time',
};
